export default __webpack_public_path__ + "static/media/list-builder-cancel-icon.9c34aac9.svg";